import { yupResolver } from '@hookform/resolvers/yup';
import { Avatar, Box, Button, Card, CardHeader, Container, Link, Stack, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { RHFTextField, RHFUploadAvatar } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/form-provider';
import { useResponsive } from 'src/hooks/use-responsive';
import CompactLayout from 'src/layouts/compact/layout';
import * as Yup from 'yup';
import { uploadImageToS3 } from 'src/services/aws.service';
import { useCallback } from 'react';
import { useSettingsContext } from 'src/components/settings';
import { getOrganizationDetails, getOrganizationId, putOrgDetails } from 'src/services/user.service';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';
import { useParams } from 'react-router';
import { useAuthContext } from 'src/auth/hooks';
import { useSnackbar } from 'src/components/snackbar';


export default function OrganizationSettings() {
  const { enqueueSnackbar } = useSnackbar();
  const settings = useSettingsContext();
  const mdUp = useResponsive('up', 'md');
  const OrgSchema = Yup.object().shape({
    org_name: Yup.string().required('Organization name is required'),
  });
  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");

  const { user } = useAuthContext();
  const org_id = getOrganizationId(user);

  const defaultValues = useMemo(
    () => ({
      org_name: '',
    }),
    [],
  );

  const methods = useForm({
    resolver: yupResolver(OrgSchema),
    defaultValues,
  });

  const { reset, setValue, handleSubmit } = methods;

  const onSubmit = handleSubmit(async data => {
    console.log(data);
  });

  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];

    const newFile = Object.assign(file, {
      preview: URL.createObjectURL(file),
    });

    if (file) {
      setValue('avatarUrl', newFile, { shouldValidate: true });
      uploadImageToS3(file).then(data => {
        console.log("image-url = ", data)
        setOrgLogo(data);
        // console.log("this is logo = ",orgLogo)
        let imgPayload = {
          "name": orgName,
          "org_logo_url": data,
        }
        console.log("payload = ", imgPayload);
        putOrgDetails(imgPayload, org_id).then(data => {
          console.log(data);
          enqueueSnackbar('Saved Successfuly');
        })

      })
    }
  };

  const handleMouseOut = async (data) => {
    const payload = {
      "name": data.target.value,
      "org_logo_url": orgLogo
    }
    setOrgName(data.target.value);
    // console.log(data.target.value)
    console.log("payload = ", payload)
    try {
      const res = await putOrgDetails(payload, org_id);
      console.log(res);
      enqueueSnackbar('Saved Successfuly');
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const callerFunc = async () => {
      try {
        const res = await getOrganizationDetails(org_id);
        console.log(res);
        if (res.success) {
          setValue('avatarUrl', res.body.org_logo_url, { shouldValidate: true });
          setValue('org_name', res.body.org_name);
          setOrgLogo(res.body.org_logo_url);
          setOrgName(res.body.org_name);
        }
      } catch (error) {
        console.log(error)
      }
    }
    callerFunc();
  }, []);

  return (
    // <Container sx={{ margin: "auto", display: "flex", alignItems: "center", height: "100%" }}>
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Card sx={{ p: 3, minHeight: "50vh", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <Stack spacing={3} sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <Stack sx={{ disply: "flex", flexDirection: "column", justifyContent: "center" }}>
            <Box >
              <RHFUploadAvatar
                name="avatarUrl"
                maxSize={1000000}
                onDrop={handleDrop}
              />
            </Box>
            {/* <Button variant="contained" >Save</Button> */}
          </Stack>
          <Stack alignItems="flex-start" justifyContent="center" spacing={1.5} sx={{ width: "100%" }} >
            <Typography variant="h5">Organization Name</Typography>
            <RHFTextField name="org_name" onBlur={handleMouseOut} />
          </Stack>
        </Stack>
        {/* <Stack sx={{ textAlign: "center" }}>
          <Link
            component={RouterLink}
            href={paths.dashboard.root}
            color="inherit"
            variant="subtitle2"
            sx={{
              alignItems: 'center',
              display: 'inline-flex',
              margin: "auto",
            }}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={16} />
            Return to dashboard
          </Link>
        </Stack> */}
      </Card>
    </FormProvider>

    // </Container>
  );
}
